import React from 'react';
// ---- external imports ----

import backdropProjection from '~/assets/images/baseAssets/asset-bg.jpg';
import Backdrop from '~/components/Backdrop';
// ---- internal imports ----


function AssetBackdrop(props) {
	return (
		<Backdrop
			size={BACKDROP_SIZE}
			projection={backdropProjection}
			data-testid={props['data-testid']}
		>
			{props.children}
		</Backdrop>
	);
}

const BACKDROP_SIZE = {
	width: 1366,
	height: 768,
};


export default AssetBackdrop;
